import { styled } from '@mui/material'
import { InitialsAvatar } from '@omnea-app/fe-users-and-groups/avatar/InitialsAvatar'

const Icon = styled(InitialsAvatar)(({ theme }) => ({
  marginRight: theme.spacing(3),
}))

/** The organisation's square icon, or its initial when there is none to show. */
export const OrgIcon = ({ name, src }: { name: string; src?: string }) => (
  <Icon fullName={name[0] || '!'} variant="square" size={32} src={src} alt="" aria-hidden />
)
